/* eslint-disable eqeqeq */
import React, { createRef, useContext } from "react";
import { Col, Form, Row, Button } from "react-bootstrap";
import { FaFilePdf } from "react-icons/fa";
import { AuthContext } from "../../contexts/AuthProvider";
import "./Result.css";

import Pdf from "react-to-pdf";
const ref = createRef();

const Result = ({ clientName,proposalLetter,questions }) => {

  const { user } = useContext(AuthContext);
  const firstLine = 'Dear ' + clientName + ',';
  var cont = true;
  console.log(proposalLetter);
  if (proposalLetter !== 'Exhausted 10 Free trials for the day') {  
    var propLetter = proposalLetter.split("\n");
    // console.log('array is',propLetter)
    const letterLength = propLetter.length;
    propLetter[letterLength - 1] = user.displayName;
    return (
      <>
        <Row>
          <Col md={9} >

            <Form
              className="my-3 bg-form pb-3 shadow mb-3 rounded"
            >

              <div ref={ref} style={{ height: 'auto' }}>

                <div className="mb-4 p-4"
                >
                  <h3 className="img-fluid"><b>PROPOSAL</b></h3>
                  <div>
                    {propLetter.map((data, index) => {
                      
                      if(clientName && data.match("Dear")){
                        {console.log('index is ',index)}
                        return(
                          <span key={index}>{firstLine}<br/></span>
                        )
                      }
                      else if(user && (data.match("Your Name") || data.match("Your name") ) ){
                        {console.log('index is ',index)}
                        cont = false;
                        return(
                          <span key={index}>{user.displayName}<br/></span>
                        )
                      }
                      else if(cont){
                          if(index == 12){
                            {console.log('index is',index)}
                            return (
                              <>
                              <br/>
                              <div>Questions : </div>
                              <div>
                              {
                                questions.map((data,index)=>{
                                  return (
                                    <>
                                      <div>
                                        {
                                          index+1
                                        }
                                        . 
                                        {
                                          data.question
                                        }
                                      </div>
                                      <div> Answer : 
                                        {
                                          data.answer
                                        }
                                      </div>
                                    <br/>
                                    </>
                                  )
                                })
                              }
                              </div>
                              
                            </>
                            )

                          }                        
                        return(
                          <>
                            <span key={index}>{data}<br/></span> 
                          </>
                                                   
                        )
                      }
                      else{
                        return false;
                      }
                    })    
                    }
                    
                    {/* <div>Questions : </div>{
                      questions.map((data,index)=>{
                        return (
                          <>
                            <div>
                              {
                                index+1
                              }
                              . 
                              {
                                data.question
                              }
                            </div>
                            <div> Answer : 
                              {
                                data.answer
                              }
                            </div>
                          
                          </>
                        )
                      })
                    } */}
                  </div>
                </div>
              </div>
              <Pdf targetRef={ref} filename="Proposal.pdf">
                {({ toPdf }) => <Button variant="primary" className="ms-4" onClick={toPdf}><FaFilePdf /> Download Pdf </Button>}
              </Pdf>
              <Button variant="success" className="ms-4" onClick={() => window.location.reload(true)}> New Request </Button>
            </Form>
          </Col>
        </Row>

      </>
    );}
  else {
    return (
      <>
        <Row>
          <Col md={7} >
  
            <Form
              className="my-3 bg-form pb-3 shadow mb-3 rounded"
            >
  
              <div ref={ref} style={{ height: 'auto' }}>
  
                <div className="mb-4 p-4"
                >
                  <h5 className="img-fluid"><center>Exhausted 10 Free trials for the day</center></h5>
                </div>
  
              </div>
            </Form>
          </Col>
        </Row>
  
      </>
    );
  }
};

export default Result;
